import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { AboutIncentivesModal } from 'site-modules/shared/components/incentives/about-incentives-modal/about-incentives-modal';

export function IncentivesNarrativeModel({ hasAboutModal = true }) {
  return (
    <section className="narrative-model text-gray-darker medium">
      <div className={classnames({ 'mb-0_5': hasAboutModal })}>
        Customer Incentives and Rebate information is provided subject to the terms of our{' '}
        <a
          href="/about/visitor-agreement.html"
          target="_blank"
          rel="noopener noreferrer"
          data-tracking-id="link_select_tool_select"
        >
          <u>Visitor Agreement</u>
        </a>
        . See participating dealers for additional details. Dealer participation may vary.
      </div>
      {hasAboutModal && <AboutIncentivesModal />}
    </section>
  );
}

IncentivesNarrativeModel.propTypes = {
  hasAboutModal: PropTypes.bool,
};
